import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-specification.reducer';

export const ProductSpecificationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productSpecificationEntity = useAppSelector(state => state.productSpecification.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productSpecificationDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productSpecification.detail.title">ProductSpecification</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productSpecificationEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="crawlerBackendApp.productSpecification.name">Name</Translate>
            </span>
          </dt>
          <dd>{productSpecificationEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="crawlerBackendApp.productSpecification.description">Description</Translate>
            </span>
          </dt>
          <dd>{productSpecificationEntity.description}</dd>
          <dt>
            <span id="unit">
              <Translate contentKey="crawlerBackendApp.productSpecification.unit">Unit</Translate>
            </span>
          </dt>
          <dd>{productSpecificationEntity.unit}</dd>
          <dt>
            <span id="validFrom">
              <Translate contentKey="crawlerBackendApp.productSpecification.validFrom">Valid From</Translate>
            </span>
          </dt>
          <dd>
            {productSpecificationEntity.validFrom ? (
              <TextFormat value={productSpecificationEntity.validFrom} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="validTo">
              <Translate contentKey="crawlerBackendApp.productSpecification.validTo">Valid To</Translate>
            </span>
          </dt>
          <dd>
            {productSpecificationEntity.validTo ? (
              <TextFormat value={productSpecificationEntity.validTo} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button tag={Link} to="/product-specification" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/product-specification/${productSpecificationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductSpecificationDetail;
